export default "__VITE_ASSET__cf43b45f__"